import React from 'react';
import {
    BrowserRouter as Router,
    Link,
  } from "react-router-dom";
import moment from 'moment';
import { trim, contains } from 'ramda';
import {
    useParams
  } from "react-router-dom";

import './HorseIndex.scss';
import Favorite from './Favorite';

export default function HorseIndex({ horse, sale, style, consignorIDInt = null, onClick}) {
    if (!horse) {
        return null;
    }

    const year_of_birth = moment(horse.year_of_birth, ["MM/DD/YYYY","YYYY-MM-DD"]).isValid() ? moment(horse.year_of_birth, ["MM/DD/YYYY","YYYY-MM-DD"]).format('YY') : null;
    const year_of_sale = moment(global.drupalSettings.catalogues.sale_start_date ["MM-DD-YYYY", "YYYY-MM-DD"]).isValid() ? moment(global.drupalSettings.catalogues.sale_start_date, ["MM-DD-YYYY", "YYYY-MM-DD"]).format('YY') : null;
    const novemberDisplay = year_of_birth !== year_of_sale  ? `${horse.name}` : `'${year_of_birth} ${horse.sex}. `;
    const index_label = global.drupalSettings.catalogues.sale_name.indexOf('November') !== -1 ? novemberDisplay : `${horse.name}`;
    const firstPart = consignorIDInt ? consignorIDInt : 'sale';

    const topLine = trim(horse.name) && !contains(horse.sold_as_code, ['W','Y']) ? (
        <div className="birth-year">
            {trim(horse.name)}
        </div>
    ) : (
        <div className="birth-year">
            '{year_of_birth} {horse.sex}.
        </div>
    );

    const outBox = (<div className="out-box">
        <div className="out-box-content">
            Out
        </div>
    </div>);

    const outBoxOutput = horse.out && sale.show_outs && outBox;

    return (
        <Link to={`/${firstPart}/${horse.hip}`} onClick={(e)=> {console.log(e); onClick()}}>
            <div className="horse-index"
                style={style}
            >
                {outBoxOutput}
                <div className="hip-number"
                >
                    {horse.hip}
                </div>
                <Favorite horse={horse} />
                {topLine}
                <div className="sire-dam">
                    {horse.sire}/{horse.dam}
                </div>
                <div
                    className="consignor text-right"
                >
                    {horse.consignor}
                </div>
            </div>
        </Link>
    );
}
